<template>
  <div class="message-item">
    <div class="title">{{ title }}</div>
    <div class="desc">{{ desc }}</div>
    <div class="handle">
      <div class="time">{{ time }}</div>
      <el-link type="primary" :underline="false" v-if="isLink" @click="$emit('click')">查看详情</el-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'message-item',
  props: {
    title: String,
    desc: String,
    time: String,
    isLink: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style scoped lang="less">
.message-item {
  padding-bottom: 10px;
  border-bottom: 1px solid #eeeeee;
  margin-bottom: 20px;

  .title {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    color: #333333;

  }

  .desc {
    font-size: 14px;
    font-weight: 400;
    line-height: 26px;
    color: #555;
    margin-top: 5px;
  }

  .handle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 5px;

    .time {
      font-size: 14px;
      font-weight: 400;
      line-height: 24px;
      color: #BFBFBF;
    }
  }
}
</style>
